import useWindowSize from './use-window-size';

export interface DeviceFeature {
    isPhone: boolean;
}

const useDeviceFeature = () => {
    const {width} = useWindowSize();

    const feature: DeviceFeature = {
        isPhone: width < 450,
    };

    return feature;
};

export default useDeviceFeature;
